import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';

const FacilityWrapper = styled.div.attrs(() => {
  const classNameToAdd = ['u-block-margins'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FacilityTitle = styled.h2.attrs(() => {
  const classNameToAdd = ['h3', 'text-basic-700', 'mb-8'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FacilityItemsWrap = styled.div.attrs(({ showAllItems }) => {
  const baseClassNames = [
    '-mx-2',
    'flex',
    'flex-wrap',
    'overflow-hidden',
    'duration-500',
    'ease-in-out',
    'transition-maxHeight',
    'lg:-mx-3',
  ];
  const classNameToAdd = showAllItems
    ? [...baseClassNames, 'max-h-1000']
    : [...baseClassNames, 'max-h-200', 'sm:max-h-100', 'md:max-h-110', 'lg:max-h-150', 'xxl:max-h-180'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FacilityItem = styled.div.attrs(() => {
  const classNamesToAdd = [
    'h-facilitySm',
    'px-2',
    'mb-4',
    'flex-1/3',
    'max-w-1/3',
    'sm:flex-1/4',
    'sm:max-w-1/4',
    'md:flex-1/6',
    'md:max-w-1/6',
    'md:h-facilityMd',
    'lg:px-3',
    'lg:h-facilityLg',
    'xl:mb-5',
    'xl:flex-1/8',
    'xl:max-w-1/8',
    'xxl:h-facilityXxl',
  ];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

const FacilityName = styled.span.attrs(() => {
  const classNameToAdd = [
    'leading-3',
    'md:leading-4',
    'lg:leading-5',
    'p-1',
    'pt-3',
    'w-full',
    'text-basic-700',
    'text-xs',
    'lg:text-sm',
    'xxl:text-base',
    'tracking-normal',
    'hyphenate',
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FacilityToggleWrap = styled.span.attrs(() => {
  const classNameToAdd = [
    'inline-block',
    'w-full',
    'flex',
    'justify-center',
    'font-base',
    'font-bold',
    'text-basic-700',
    'pt-4',
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FacilityToggle = styled.span.attrs(() => {
  const classNameToAdd = ['cursor-pointer', 'flex', 'leading-8'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

export {
  FacilityWrapper,
  FacilityTitle,
  FacilityItemsWrap,
  FacilityItem,
  FacilityName,
  FacilityToggle,
  FacilityToggleWrap,
};
